export const internalSalesCampaign = {
	title: "Campañas internas",
	subtitle:
		"Cree campañas internas, dé seguimiento al progreso y gestione el pago de bonificaciones.",
	tabs: {
		campaign: "Campañas",
		bonusManagement: "Gestión de bonificación",
	},
	messages: {
		errorMsg: "Error al cerrar la campaña",
		errorDescriptionError:
			"Por favor, intente nuevamente más tarde o contacte al soporte.",
		successMsg: "¡Éxito!",
		successDescription: "¡Se ha creado una campaña!",
		warnMsg: "Cerrar campaña",
		warnDescription:
			"Esta campaña finalizará antes del período establecido. Si la campaña ya ha iniciado, esto podría impactar directamente en la meta de los colaboradores y en las ventas. ¿Desea continuar?",
		closeCampaignMsg: "Sí, cerrar campaña",
		close: "Cerrar",
		editcampaign: "Editar campaña",
		duplicateCampaign: "Duplicar campaña",
		closeCampaignBtn: "Cerrar campaña",
	},
	campaignDetails: {
		back: "Volver",
		summary: "Resumen",
		position: "Posición",
		points: "Puntos",
		downloadExcel: "Exportar a Excel",
		resultsPerPage: "Resultados por página",
		operator: "OPERADOR (USER)",
		ranking: "Ranking de operadores",
	},
	modal: {
		confirmationTitle: "Su campaña no fue creada",
		continuebtn: "No, continuar configuración",
		exitBtn: "Sí, salir sin guardar",
		content:
			"Al salir, las configuraciones de la campaña se perderán y esta acción no se podrá deshacer. ¿Desea continuar?",
	},
	steps: {
		generalSettings: "Configuraciones generales",
		generalSettingsDetails: "Configure los detalles de su campaña.",
		withBonusExtra:
			"El {{position}}º lugar en el ranking general ganará el bono extra de",
		withBonus: "El {{position}}º lugar en el ranking general ganará el bono de",
		salesTarget: "Meta de ventas",
		selectWinners: "Seleccione el/los ganador(es) y configure el valor:",
		prizeByRanking: "Premiar por ranking",
		addPositionToRanking: "Agregar posición al ranking",
		onlyFirstPlace: "Solo el 1er lugar en el ranking general",
		onlyFirstAndSecondPlace: "Solo el 1er y 2do lugar en el ranking general",
		top3: "Solo el top 3 en el ranking general",
		allOperators: "Todos los que alcancen la meta",
		bonus: "Bonificación",
		winnerQuantity: "Cantidad de ganador(es)",
		winnerQuantityPlaceholder: "Seleccione la cantidad de ganadores",
		summary: "Resumen",
		cancel: "Cancelar",
		allSettings: "Todas las configuraciones",
		back: "Volver",
		next: "Siguiente",
		finish: "Finalizar",
		campaignLocale: "Local de la campaña",
		campaignLocalePlaceholder: "Seleccione uno o más locales para esta campaña",
		campaignName: "Nombre de la campaña",
		charCount: "Cantidad máxima de caracteres: 20",
		campaignNamePlaceholder: "Ingrese el nombre de la campaña",
		sponsor: "Patrocinador (opcional)",
		sponsorPlaceholder: "Ingrese el nombre del patrocinador",
		salesTargetDescription: "Elija el tipo de meta en que se enfocará su campaña.",
		campaign: "Campaña",
		campaignSubtitle: "Configure los detalles de su campaña.",
		startDate: "Fecha inicial de la campaña",
		endDate: "Fecha final de la campaña",
		dateInfo:
			"Atención: La campaña solo podrá ser editada hasta 30 minutos antes del horario programado para iniciar.",
		types: {
			soldProducts: "Por producto",
			soldProductsPlaceholder: "Seleccione uno o más productos",
			soldProductsMetaAlertTitle: "Cantidad de productos vendidos.",
			soldProductsMetaAlert:
				"La meta será la suma de todos los productos seleccionados vendidos.",
			soldProductsDescription:
				"Defina un producto estratégico como meta para su campaña.",
			productsQuantity: "Meta de ventas (cant.)",
			selectProducts: "Producto",
			salesTotal: "Por valor total en ventas",
			salesTotalDescription: "Defina un valor total en ventas como meta para su campaña.",
			salesTotalGoal: "Valor de la meta",
			metaType: "Tipo de meta",
			metaTypeTooltip:
				"La meta es el objetivo de la campaña y sirve para medir el desempeño de los colaboradores. Puede ser definida por: cantidad de productos vendidos, número de atenciones o valor total en ventas.",
			selectTypeGoal: "Seleccione el tipo de meta",
			attendance: "Por atención",
			attendanceGoal: "Cantidad",
			attendanceDescription:
				"Defina una cantidad de atención (de personas o mesas) como meta para su campaña.",
		},
		bonusContent: {
			title: "Bonificación",
			subtitle:
				"Seleccione y configure el tipo de bonificación a ser concedida al colaborador.",
			moneyTitle: "Bono en efectivo",
			moneySubtitle: "Bono con pago en efectivo o vía PIX.",
			bonusTitle: "Cashless Zig",
			bonusSubtitle:
				"Bono disponible en el RFC o en la tarjeta de consumo Cashless Zig del/los colaborador(es).",
			featuredContribuitorTitle: "Colaborador destacado",
			featuredContribuitorSubtitle:
				"Esta bonificación es un reconocimiento por mérito. La aplicación será definida por el gestor.",
			slackTitle: "Día libre extra",
			slackSubtitle:
				"Este bono concede un día libre extra, además del regular. La aplicación será definida por el gestor.",
			winnersQuantity: "Cant. de ganador(es)",
			firstPlaceBonus: "Bono 1er lugar",
			scondPlaceBonus: "Bono 2do lugar",
			thirdPlaceBonus: "Bono 3er lugar",
		},
		resume: {
			title: "Resumen",
			subtitle: "Revise el resumen de la configuración de la campaña.",
			warning:
				"Atención: Después de la creación de la campaña, la misma solo podrá ser editada hasta 30 minutos antes del horario programado para iniciar.",
			geralSettings: "Configuraciones generales",
			campaignLocale: "Local de la campaña",
			campaignName: "Nombre de la campaña",
			sponsor: "Patrocinador",
			schedule: "Programación",
			initialDate: "Fecha inicial de la campaña",
			endDate: "Fecha final de la campaña",
			goal: "Meta de ventas",
			type: "Tipo",
			goalSell: "Meta de ventas",
			product: "Producto",
			bonus: "Bonificación",
			bonusType: "Tipo de bonificación",
			winnerQuantity: "Cantidad de ganador(es)",
			allOperators: "Todos los operadores que alcancen la meta ganarán el bono de",
		},
	},
	bonusManagement: {
		filters: {
			campaignName: "Filtrar por nombre de la campaña",
			campaignStatus: "Filtrar por estado",
			operatorName: "Filtrar por nombre de operador",
			pending: "Pendiente",
			done: "Efectuado",
		},
		paymentType: {
			bonus: "Bono",
			dayOff: "Día libre extra",
			employeeOfTheMonth: "Colaborador del mes",
			money: "Efectivo",
			pix: "PIX",
		},
		table: {
			status: "ESTADO",
			campaignName: "CAMPAÑA",
			operator: "OPERADOR",
			bonusType: "TIPO DE BONO",
			value: "VALOR",
			retrievedAt: "EFECTUADO EN",
			retrievedBy: "RESPONSABLE",
			confirmBonus: "Confirmar bono",
		},
	},
	newCampaign: "Crear campaña",
	campaign: {
		cards: {
			active: "Campañas activas",
			campaignsProgramed: "Campañas programadas",
			campaignsConcluded: "Campañas concluidas",
			totalProductsSold: "Total en venta",
			onSale: "Campañas en curso",
		},
		filters: {
			campaignName: "Filtrar por nombre de la campaña",
			campaignStatus: "Filtrar por estado",
			operatorName: "Filtrar por nombre de operador",
		},
		table: {
			noContent: "Ninguna campaña encontrada",
			checkFilters: "Cree una campaña o verifique los filtros.",
			status: "ESTADO",
			campaignName: "CAMPAÑA",
			start: "INICIO",
			end: "FIN",
			metaType: "TIPO DE META",
			productsSell: "PRODUCTOS VENDIDOS",
			services: "ATENCIONES",
			totalValue: "VALOR TOTAL",
			edit: "Editar campaña",
			duplicate: "Duplicar campaña",
			finish: "Cerrar campaña",
		},
		tags: {
			active: "Activa",
			finished: "Finalizada",
			scheduled: "Programada",
			onSale: "En curso",
		},
	},
};
